import React from 'react';
import Account from './Account';
const AccountS = ({ color, ...props }) => (React.createElement(Account, Object.assign({ color: color, size: 24 }, props)));
AccountS.displayName = 'AccountS'; // Fix for tsc
export default AccountS;
//# sourceMappingURL=AccountS.js.map